import { createContext } from 'react';

export const ApiUrlContext = createContext<string>('');
